module.exports = __webpack_public_path__ + "img/icon_sns_01.0090b1c9.svg";